import { Component } from '@angular/core';
import { correctHeight, detectBody } from '../../../app.helpers';

declare var jQuery: any;

@Component({
    selector: 'basicEmpresa',
    templateUrl: 'basic-empresa.template.html'
})
export class basicComponentEmpresa { 
    onResize(event) {
        const innerWidth = event.target.innerWidth;
        correctHeight();
        detectBody();
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/components/common/layouts/basic-empresa.component.ts